import { render, staticRenderFns } from "./tab-slider.vue?vue&type=template&id=0d16958a&scoped=true"
import script from "./tab-slider.vue?vue&type=script&lang=js"
export * from "./tab-slider.vue?vue&type=script&lang=js"
import style0 from "./tab-slider.vue?vue&type=style&index=0&id=0d16958a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16958a",
  null
  
)

export default component.exports